






























  import RadioGroup from '@/commun/components/radio-group/radio-group.vue';
  import Vue from 'vue';
  import DemandeProgramme, {
    DemandeProgrammeTypeModification,
  } from '@/domain/models/demande-programme';
  import { SectionFormulaireProgramme } from '@/components/faculte/demandes/formulaires/programme/section-formulaire-programme';

  export default Vue.extend({
    name: 'RadioMajeure',
    components: { RadioGroup },
    mixins: [SectionFormulaireProgramme],
    props: {
      estRadioDesactive: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      demandeCourante: {} as DemandeProgramme,
      nouvelleMajeure: DemandeProgrammeTypeModification.MAJEURE_NOUVELLE,
      majeureExistante: DemandeProgrammeTypeModification.MAJEURE_EXISTANTE,
    }),
  });
